// extracted by mini-css-extract-plugin
export default {"AllPurchases":"AllPurchases_AllPurchases__DT9xj"};